import $ from 'jquery';
import EFOcats_event_addCheck from '../../../core/v2/event/efocats_event_addCheck';

export default class EFOcats_iwatani_event_addCheck extends EFOcats_event_addCheck {
  event() {
    super.event();

    this.$('input[validate-type="compare"]').on('change', event => {
      const element = event.currentTarget;
      const obj = $(element);

      obj
        .parents('.cat-section')
        .find(`input[validate-type="compare"]`)
        .each((index, elem) => {
          if ($(elem).val() === '') {
            return;
          }
          efocats.validations.check_error($(elem), false);
        });
    });
  }
}
